const WAIT_INTERVAL_TIMEOUT = 100

const waitForPackName = setInterval(() => {
  if (
    document.querySelector('.product-option')
    && document.querySelector('.pack.selected .name')
    && document.querySelector('.small-circle')
  ) {
    clearInterval(waitForPackName)

    document.querySelector('.product-option').innerText = document.querySelector('.pack.selected .name').innerText
    document.querySelector('.small-circle').classList.remove('small-circle--hidden')

    setTimeout(() => {
      clearInterval(waitForPackName) // Stop the interval after a certain time (e.g., 30 seconds)
    }, 30000)
  }
}, WAIT_INTERVAL_TIMEOUT)

addCompatibilityAndAboutSection()
updatePrice()
updateDelivery()
addScrollToYotpoReviews()
clickOnAddToCart()
changeInitDiscountText()

function waitForElement(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector))
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector))
        observer.disconnect()
      }
    })

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    })
  })
}

function addCompatibilityAndAboutSection() {
  const waitForEl = setInterval(() => {
    if (
      document.querySelector('.product__description > ul')
      && document.querySelector('.product__description .btn_more')
    ) {
      clearInterval(waitForEl)

      const list = document.querySelector('.product__description > ul')
      const btnMore = document.querySelector('.product__description .btn_more')

      list.insertAdjacentHTML('beforebegin', `
      <div class="d-lg-flex d-none compatibility_block_wrapper">
        <div class="compatibility_block">
         <img src="https://cdn.shopify.com/s/files/1/2612/6532/files/compatibility-alexa.png?v=1700665355" alt="alexa">
        </div>
        <div class="compatibility_block">
         <img src="https://cdn.shopify.com/s/files/1/2612/6532/files/compatibility-google.png?v=1700665354" alt="google">
        </div>
      </div>
      <p class="title title_about">About this product</p>`)

      btnMore.addEventListener('click', () => {
        list.classList.toggle('active')
        if (list.classList.contains('active')) {
          btnMore.querySelector('span').innerHTML = 'See less'
        } else {
          btnMore.querySelector('span').innerHTML = 'See more'
        }
      })

    }
  }, WAIT_INTERVAL_TIMEOUT)
}

function updatePrice() {
  const waitForEl = setInterval(() => {
    if (document.querySelector('.quantity__selector.quantity__input')
      && document.querySelector('.product__price--regular')
      && document.querySelector('.product__price--compare')
      && document.querySelector('.sticky-btn-wrapper__price')
    ) {
      clearInterval(waitForEl)

      const input = document.querySelector('.quantity__selector.quantity__input')

      const productCurrentPrice = document.querySelector('.product__price--regular').innerText
      const productComparePrice = document.querySelector('.product__price--compare').innerText

      setInterval(() => {
        document.querySelector('.product__price--regular').innerText = calculateTotalPrice(productCurrentPrice, input.value)
        document.querySelector('.product__price--compare').innerText = calculateTotalPrice(productComparePrice, input.value)
        document.querySelector('.sticky-btn-wrapper__price').innerText = calculateTotalPrice(productCurrentPrice, input.value)
      }, 1000)

      function calculateTotalPrice(prText, quantity) {
        if (prText !== "$0.00" && prText !== "$0" && prText !== "") {
          const numericPrice = parseFloat(prText.replace('$', ''))

          const result = numericPrice * quantity

          const formattedResult = '$' + result.toFixed(2) // Assuming you 

          return formattedResult
        } else {
          return ''
        }
      }
    }
  }, WAIT_INTERVAL_TIMEOUT)
}

function updateDelivery() {
  const waitForEl = setInterval(() => {
    if (
      document.querySelector('.product__accordions .product__accordion__content p')
      && document.querySelector('[data-delivery-price]')
      && document.querySelector('[data-delivery-return]')
      && document.querySelector('[data-delivery-date]')
    ) {
      clearInterval(waitForEl)

      document.querySelector('[data-delivery-price]').innerText = document.querySelector('.product__accordions .product__accordion__content p').innerHTML.split('on orders')[1].split('+')[0]

      document.querySelector('[data-delivery-return]').innerText = document.querySelector('.product__accordions .product__accordion__content p').innerHTML.split('free ')[1].split('returns')[0]

      document.querySelector('[data-delivery-date]').innerText = formatDate()

      //get the current date + 7 days in the format: Fri, Aug 11 (19)
      function formatDate() {
        const today = new Date()
        const deliveryDate = new Date(today)
        let addedBusinessDays = 0

        while (addedBusinessDays < 7) {
          // Move to the next day
          deliveryDate.setDate(deliveryDate.getDate() + 1)

          // Check if the current day is a weekend day (Saturday or Sunday)
          if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
            addedBusinessDays++
          }
        }

        const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        const deliveryDayOfWeek = daysOfWeek[deliveryDate.getDay()]
        const deliveryMonth = months[deliveryDate.getMonth()]
        const deliveryDay = deliveryDate.getDate()

        const formattedDate = `${deliveryDayOfWeek}, ${deliveryMonth} ${deliveryDay}`

        return formattedDate
      }
    }
  }, WAIT_INTERVAL_TIMEOUT)
}

function addScrollToYotpoReviews() {
  const intervalId = setInterval(() => {
    const reviewLinks = document.querySelectorAll('.review-link a')
    const reviewsBlockHeader = document.querySelector('[id*="4fd1080e-3c77-4419-97cf-9077fd1b87ac"]')

    if (reviewLinks.length >= 2 && reviewsBlockHeader) {
      const sectionId = reviewsBlockHeader.id

      reviewLinks.forEach((reviewLink, index) => {
        reviewLink.addEventListener('click', function (event) {
          event.preventDefault()

          // Scroll to the target section smoothly with a top offset
          const targetSection = document.querySelector('#' + sectionId)
          const offset = 60 // Adjust this value as needed
          const bodyRect = document.body.getBoundingClientRect().top
          const targetRect = targetSection.getBoundingClientRect().top
          const scrollTo = targetRect - bodyRect - offset

          window.scrollTo({
            top: scrollTo,
            behavior: 'smooth',
          })
        })
      })

      clearInterval(intervalId) // Stop the interval once the elements are found
    }
  }, WAIT_INTERVAL_TIMEOUT)

  setTimeout(() => {
    clearInterval(intervalId) // Stop the interval after a certain time (e.g., 30 seconds)
  }, 30000)
}

function clickOnAddToCart() {
  const waitForEl = setInterval(() => {
    if (
      document.querySelector('.sticky-btn-wrapper .add-to-cart ')
      && document.querySelector('button[name="add"]')
    ) {
      clearInterval(waitForEl)

      document.querySelector('.sticky-btn-wrapper .add-to-cart ').addEventListener('click', () => {
        document.querySelector('button[name="add"]').click()
      })
    }
  }, WAIT_INTERVAL_TIMEOUT)
} 

function changeInitDiscountText() {
  const req = /(\d{1,})(\d{2})$/ // Regular expression to extract a number with a dollar sign ($) and optional '+' sign 

  fetch(`/cart.js`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  }).then(res => res.json()).then(data => {
    const total = +(data['total_price'].toString().replace(req, "$1.$2"))
    
    let discount = ``

    if (total >= 0 && total <= 99.00) {
      discount = `Spend <b>$99</b> and get a <b>10% discount</b>`
    } else if (total > 99.00 && total <= 149.00) {
      discount = `Spend <b>$149</b> and get a <b>15% discount</b>`
    } else if (total > 149.00) {
      discount = `Spend <b>$199</b> and get a <b>20% discount</b>`
    }

    waitForElement('.pdp-price-wrapper .discount p').then(el => el.innerHTML = discount)

  }).catch((error) => {
    console.error('Error:', error)
  })
}